import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

import HelmetProvider from '@app/providers/HelmetProvider/HelmetProvider';
import cat from '@app/images/content/quality-of-life/cat.svg';
import dog from '@app/images/link-icons/dog.svg';
import symptom from '@app/images/link-icons/vet.svg';
import { ResourceTopic } from '@app/objects/ResourceTopic';
import '@app/scss/components/resourcesPage.scss';

const ResourcesCenterPage: React.FC<{ topics: Array<ResourceTopic> }> = ({ topics }) => {
	const topicImages = {
		'common-diseases-in-cats': cat,
		'common-diseases-in-dogs': dog,
		'symptom-management': symptom,
	};

	return (
		<HelmetProvider ignoreServerPage>
			<>
				<Helmet>
					<title>Family Resource Center | Lap of Love</title>
				</Helmet>
				<div className="resources-page">
					<h3>View our resources to learn more about caring for your geriatric or terminally ill pet</h3>
					<div className="resources-page__block">
						{topics?.length ? (
							topics.map((item) => {
								return (
									<Link to={`/resource-center/${item.url}`} key={item.id} className="resources-page__card">
										<img style={{ width: 100, height: 100 }} src={topicImages[item.url]} alt="" />
										<h5>{item.title}</h5>
									</Link>
								);
							})
						) : null}
					</div>
				</div>
			</>
		</HelmetProvider>
	);
};

export default ResourcesCenterPage;
